import { InjectionToken } from '@angular/core'

export const UPDATE_USER_DIALOG_ID = 'UPDATE_USER_DIALOG' as const
export const DETAILS_USER_DIALOG_ID = 'DETAILS_USER_DIALOG_ID' as const
export const ADD_USER_DIALOG_ID = 'ADD_USER_DIALOG' as const
export const RESET_PASSWORD_DIALOG_ID = 'RESET_PASSWORD_DIALOG' as const
export const USER_GENERATED_API_KEY_DIALOG_ID =
  'USER_GENERATED_API_KEY_DIALOG_ID' as const

//ToDo: submit angular ticket to allow named outlets relative routing
/** @deprecated Use USERS_ROUTE_PREFIX injection token instead */
export const ABSOLUTE_ROUTE_PREFIX = '/navix-admin/user/s' as const

/** Injection token for the users route prefix. Defaults to navix-admin path. */
export const USERS_ROUTE_PREFIX = new InjectionToken<string>('USERS_ROUTE_PREFIX', {
  providedIn: 'root',
  factory: () => '/navix-admin/user/s'
})
